import {
  Component,
  ViewEncapsulation,
  Input,
  OnChanges,
  SimpleChanges,
  EventEmitter,
  Output,
} from "@angular/core";
import { WatchlistPageService } from "../watchlist-page.service";
import { WatchlistRowObject } from "../watchlist-page.model";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { VAIconRegistryService, closeCircle } from "@va/core-library/icons";
import { Dictionary } from "src/app/store/models/common_types";
import { ReportingPagesDataService } from "src/app/reporting-pages/reporting-pages-data.service";

@Component({
  selector: "app-watchlist-grid",
  templateUrl: "./watchlist-grid.component.html",
  styleUrls: ["./watchlist-grid.component.scss"],
  host: { class: "watchlist-grid-component" },
  encapsulation: ViewEncapsulation.None,
})
export class WatchlistGridComponent implements OnChanges {
  @Input() watchlistId: string;
  @Input() showGridFilter: boolean;
  @Input() isGridLoading: boolean;
  @Output() selectedTickers = new EventEmitter<any>();
  legacyUrl = `${window.caUrl}/app`;
  faInfoCircle = faInfoCircle;
  checked = false;
  indeterminate = false;
  listOfCurrentPageData: WatchlistRowObject[] = [];
  @Input() listOfData: WatchlistRowObject[] = [];
  @Input() lastTransactionInfo: any = [];
  listOfDisplayData: WatchlistRowObject[] = [];
  setOfCheckedId = new Set<string>();
  sortName: string | null = null;
  sortValue: string | null = null;
  apiEP: string = window.apiUrl;
  showSourceTooltip = false;
  appliedFilter: Dictionary<any> = {};
  coveragestatusList: Array<any> = [];
  widthConfig: Array<string> = [
    "150px",
    "150px",
    "240px",
    "180px",
    "180px",
    "200px",
    "180px",
    "150px",
    "100px",
    "150px",
    "150px",
    "180px",
    "160px",
    "280px",
  ];
  watchlistGridLoading = true;
  mapOfSort: { [key: string]: string | null } = {
    ticker: null,
    bbgTicker: null,
    name: null,
    lastModelReceivedSort: null,
    lastRevisionsDateSort: null,
    lastReportedEarningsSort: null,
    nextEarningsSort: null,
    coveragestatus: null,
    sources: null,
    initiationDateSort: null,
    country: null,
    region: null,
    sector: null,
    industry: null,
  };
  sectorList: Array<string> = [];
  regionList: Array<string> = [];
  // coveragestatusList: Array<string> = ["[All]"];
  constructor(
    private dataService: WatchlistPageService,
    private reportPageDataService: ReportingPagesDataService,
    private iconRegistry: VAIconRegistryService,
  ) {
    this.getCoverageStatus();
    this.iconRegistry.registerIcons([closeCircle]);
  }

  getCoverageStatus() {
    this.coveragestatusList.push("[All]");
    this.reportPageDataService.getCoverageStatus().subscribe((response) => {
      response.forEach((item) => {
        this.coveragestatusList.push(item);
      });
    });
  }
  ngOnChanges(changes: SimpleChanges) {
    if (
      (changes.watchlistId &&
        changes.watchlistId.currentValue !==
          changes.watchlistId.previousValue) ||
      (changes.listOfData &&
        changes.listOfData.currentValue !== changes.listOfData.previousValue)
    ) {
      this.gridBind();
    }
    if (
      changes.lastTransactionInfo &&
      changes.lastTransactionInfo.currentValue !==
        changes.lastTransactionInfo.previousValue
    ) {
      this.bindLastTransactionInfo();
    }
  }

  bindLastTransactionInfo() {
    this.listOfData = this.bindTransactionInfo(this.listOfData);
    this.listOfDisplayData = this.bindTransactionInfo(this.listOfDisplayData);
  }

  bindTransactionInfo(list) {
    return list.map((data) => {
      const transactionInfo = this.lastTransactionInfo[data.companyid];
      let obj = {
        lastModelReceivedSort: "",
        lastModelReceived: "",
        latestSourceId: "",
      };
      if (transactionInfo) {
        obj = {
          lastModelReceivedSort: transactionInfo.lastModelReceivedSort,
          lastModelReceived: transactionInfo.lastModelReceived,
          latestSourceId: transactionInfo.latestSourceId,
        };
      }
      return {
        ...data,
        ...obj,
      };
    });
  }

  gridBind() {
    this.getFilterDropdownData();
    this.listOfDisplayData = [];
    this.watchlistGridLoading = true;
    this.appliedFilter = {
      ticker: "",
      bbgTicker: "",
      name: "",
      sources: "",
      country: "",
      industry: "",
      sector: "[All]",
      region: "[All]",
      coveragestatus: "[All]",
    };
    // this.coveragestatusList = ["[All]"];
    this.setOfCheckedId = new Set<string>();
    this.checked = false;
    this.indeterminate = false;
    this.listOfDisplayData = [...this.listOfData];
    // By default sorting on last revision date > Latest first
    this.sort("lastRevisionsDateSort", "descend", "firstLoad");
    // getting unique content-type values from data for filter
    // this.listOfData.forEach((item) => {
    //   if (item.coveragestatus && item.coveragestatus !== "") {
    //     const i = this.coveragestatusList.findIndex(
    //       (coveragestatus: string) => coveragestatus === item.coveragestatus
    //     );
    //     if (i <= -1) {
    //       this.coveragestatusList.push(item.coveragestatus);
    //     }
    //   }
    // });
    this.watchlistGridLoading = false;
  }

  getFilterDropdownData() {
    this.dataService.getFilterData(this.watchlistId, "Region").subscribe(
      (response) => {
        if (response.status === "success") {
          this.regionList = response.data;
          this.regionList.unshift("[All]");
        }
      },
      (error) => {
        throw error;
      },
    );
    this.dataService.getFilterData(this.watchlistId, "Sector").subscribe(
      (response) => {
        if (response.status === "success") {
          this.sectorList = response.data;
          this.sectorList.unshift("[All]");
        }
      },
      (error) => {
        throw error;
      },
    );
  }

  updateCheckedSet(ticker: string, checked: boolean): void {
    if (checked) {
      this.setOfCheckedId.add(ticker);
    } else {
      this.setOfCheckedId.delete(ticker);
    }
  }

  onItemChecked(ticker: string, checked: boolean): void {
    this.updateCheckedSet(ticker, checked);
    this.refreshCheckedStatus();
  }

  refreshCheckedStatus(): void {
    this.checked = this.listOfCurrentPageData.every((item) =>
      this.setOfCheckedId.has(item.ticker),
    );
    if (this.listOfCurrentPageData.length === 0) {
      this.checked = false;
    }
    this.selectedTickers.emit(this.setOfCheckedId);
    this.indeterminate =
      this.listOfCurrentPageData.some((item) =>
        this.setOfCheckedId.has(item.ticker),
      ) && !this.checked;
  }

  onCurrentPageDataChange($event: WatchlistRowObject[]) {
    this.listOfCurrentPageData = $event;
    this.refreshCheckedStatus();
  }

  onAllChecked(value: boolean): void {
    this.listOfCurrentPageData.forEach((item) =>
      this.updateCheckedSet(item.ticker, value),
    );
    this.refreshCheckedStatus();
  }

  sort(sortKey: string, sortValue: string, callFrom?: string): void {
    this.sortName = sortKey;
    this.sortValue = sortValue;
    for (const key in this.mapOfSort) {
      this.mapOfSort[key] = key === this.sortName ? sortValue : null;
    }
    this.search(callFrom);
  }

  search(callFrom?: string): void {
    this.watchlistGridLoading = true;
    /** filter data **/

    // const filterFunc = (item: { name: string; age: number; address: string }) =>
    //   (this.searchAddress ? item.address.indexOf(this.searchAddress) !== -1 : true) &&
    //   (this.listOfSearchName.length ? this.listOfSearchName.some(name => item.name.indexOf(name) !== -1) : true);
    // const data = this.listOfData.filter(item => filterFunc(item));
    // TODO - filter function
    const data = this.filter();
    /** sort data **/
    if (this.sortName && this.sortValue) {
      if (
        this.sortName === "lastRevisionsDateSort" ||
        // this.sortName === "lastModelReceivedSort" ||
        this.sortName === "initiationDateSort" ||
        this.sortName === "nextEarningsSort" ||
        this.sortName === "lastReportedEarningsSort"
      ) {
        this.listOfDisplayData = this.dateSort(data);
      } else {
        this.listOfDisplayData = this.textSort(data);
      }

      if (callFrom === "firstLoad") {
        // setting initial data to sorted by lastRevisionsDateSort
        this.listOfData = this.listOfDisplayData;
      }
    } else {
      this.listOfDisplayData = data;
    }
    this.watchlistGridLoading = false;
  }

  filter() {
    // text match filter
    return this.listOfData.filter((item) => {
      let passFilter = 0;
      for (const key in this.appliedFilter) {
        if (
          Object.prototype.hasOwnProperty.call(this.appliedFilter, key) &&
          Object.prototype.hasOwnProperty.call(item, key)
        ) {
          if (key === "sources") {
            if (
              this.appliedFilter[key] === "" ||
              item[key]
                .toString()
                .toLowerCase()
                .localeCompare(this.appliedFilter[key].toLowerCase()) === 0
            ) {
              passFilter++;
            }
          } else if (key === "sector" || key === "coveragestatus") {
            if (
              this.appliedFilter[key] === "[All]" ||
              item[key]
                .toString()
                .toLowerCase()
                .startsWith(this.appliedFilter[key].toLowerCase()) === true
            ) {
              passFilter++;
            }
          } else if (key === "region") {
            if (this.appliedFilter[key] === "[All]") {
              passFilter++;
            } else {
              // handling for multiple values in region column
              const regions = item[key].split(", ");
              const filteredValue = regions.filter((region) => {
                return (
                  region
                    .toLowerCase()
                    .localeCompare(this.appliedFilter[key].toLowerCase()) === 0
                );
              });
              if (filteredValue.length > 0) {
                passFilter++;
              }
            }
          } else {
            if (
              item[key]
                .toString()
                .toLowerCase()
                .indexOf(this.appliedFilter[key].toLowerCase()) > -1
            ) {
              passFilter++;
            }
          }
        }
      }
      if (passFilter === Object.keys(this.appliedFilter).length) {
        return item;
      }
      return false;
    });
  }

  dateSort(data: WatchlistRowObject[]) {
    return data.sort((a, b) =>
      this.sortValue === "descend"
        ? // comparing timestamp here
          a[this.sortName!] === ""
          ? 1
          : new Date(b[this.sortName!]).getTime() >
              new Date(a[this.sortName!]).getTime()
            ? 1
            : -1
        : a[this.sortName!] === ""
          ? 1
          : new Date(a[this.sortName!]).getTime() >
              new Date(b[this.sortName!]).getTime()
            ? 1
            : -1,
    );
  }

  textSort(data: WatchlistRowObject[]) {
    return data.sort((a, b) => {
      let val = 0;
      const dataA =
        a[this.sortName] === null
          ? ""
          : typeof a[this.sortName] === "string"
            ? a[this.sortName!].toString().toLowerCase()
            : a[this.sortName!];
      const dataB =
        b[this.sortName] === null
          ? ""
          : typeof b[this.sortName] === "string"
            ? b[this.sortName!].toString().toLowerCase()
            : b[this.sortName!];
      // text comparision
      val =
        this.sortValue === "ascend"
          ? dataA === ""
            ? 1
            : dataB === ""
              ? -1
              : dataA > dataB
                ? 1
                : -1
          : dataA === ""
            ? 1
            : dataB === ""
              ? -1
              : dataB > dataA
                ? 1
                : -1;
      return val;
    });
  }

  getSourceTooltip(rowData: WatchlistRowObject) {
    if (!rowData.sourceShortName) {
      this.showSourceTooltip = false;
      rowData.sourceShortName = "";
      this.dataService
        .getLatestModelSourceName(rowData.latestSourceId, rowData.ticker)
        .subscribe(
          (response) => {
            if (response.status === "success") {
              rowData.sourceShortName = response.sourceShortName;
              this.showSourceTooltip = true;
            }
          },
          (error) => {
            throw error;
          },
        );
    }
  }

  filterApplied(event: any, col: string) {
    if (col === "sector" || col === "region" || col === "coveragestatus") {
      this.appliedFilter[col] = event;
    }
    this.search();
  }

  onClearFilter(col: string) {
    this.appliedFilter[col] = "";
    this.search();
  }
}
